import { OnSiteChannel, TemplateChannel, RTMInjectedChannel } from './channels';
import { Trigger } from './rtm-trigger';
import { Template } from 'entities/template';
import { TemplatePosition } from './template-position';

export function updateRtmTriggers(channel: OnSiteChannel, newRtmTriggers: Trigger[]): OnSiteChannel {
  return {
    ...channel,
    rtmTrigger: newRtmTriggers,
  };
}

export function updateTemplateId(channel: TemplateChannel, newTemplate: Template): TemplateChannel {
  if (channel.type === '.RTMInjectedChannel' && newTemplate.type !== 'OnsiteInjected') {
    return {
      type: '.RTMOverlayChannel',
      rtmTrigger: channel.rtmTrigger,
      templateId: newTemplate.id,
    };
  } else if (channel.type === '.RTMOverlayChannel' && newTemplate.type !== 'OnsiteMessage') {
    return {
      ...channel,
      type: '.RTMInjectedChannel',
      templateId: newTemplate.id,
    };
  }

  return {
    ...channel,
    templateId: newTemplate.id,
  };
}

export function updateInjectedTemplatePosition(
  channel: RTMInjectedChannel,
  newPosition: TemplatePosition,
): RTMInjectedChannel {
  return {
    ...channel,
    templateInjectedPosition: newPosition,
  };
}

export function updateInjectedTemplateSelector(channel: RTMInjectedChannel, newSelector: string): RTMInjectedChannel {
  return {
    ...channel,
    selector: newSelector,
  };
}
